<template>
  <wms-dialog
    v-loading="loading.getTenantInfo"
    title="租户"
    :visible.sync="visible"
    width="1000px"
    @close="handleClose"
  >
    <div v-if="visible" class="dialog_content">
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="fromData"
        :inline-message="true"
        label-width="155px"
      >
        <el-row>
          <nh-area-title>租户认证企业主体信息</nh-area-title>
          <el-col :span="24">
            <el-form-item label="企业全称" prop="businessCreditName">
              {{ fromData.businessCreditName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="统一社会信用代码" prop="businessCreditCode">
              {{ fromData.businessCreditCode }}
            </el-form-item>
          </el-col>
        </el-row>
        <nh-area-title>基础信息</nh-area-title>
        <el-row>
          <el-col :span="12">
            <el-form-item label="租户简称：" prop="tenantName">
              <el-col :span="20">
                {{ fromData.tenantName }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人：" prop="contacts">
              <el-col :span="20">
                {{ fromData.contacts }}
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="联系电话：" prop="mobile">
              <el-col :span="20">
                {{ fromData.mobile }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：" prop="address">
              <el-col :span="20">
                {{ fromData.address }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业总经理姓名：">
              <el-col :span="20">
                {{ fromData.property.properties.length ? fromData.property.properties[0].value: '' }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业总经理联系电话：">
              <el-col :span="20">
                {{ fromData.property.properties.length ? fromData.property.properties[1].value: '' }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级租户：">
              <el-col :span="20">
                {{ fromData.parentTenant }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否内部租户: " prop="freshCompany">
              <el-col :span="20">
                {{ fromData.freshCompany?'是': '否' }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col v-if="fromData.freshCompany" :span="24">
            <el-form-item label="所属分子公司: ">
              {{ fromData.ext.subCompanyName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="租户状态: " prop="status">
              <el-col :span="20">
                {{ fromData.status ? '启用' : '禁用' }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据权限：" prop="dataAuthLevel">
              <el-col :span="20">
                {{ dataStatus[fromData.dataAuthLevel] }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织结构:" prop="ext.belongCreditCode">
              <el-col :span="24">
                <el-tree
                  :data="organizationTree"
                  :props="defaultAuthorizationProps"
                />
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授权系统:" prop="ext.belongCreditCode">
              <el-col :span="24">
                <el-tree
                  :data="authorizationTree"
                  :props="defaultAuthorizationProps"
                />
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="备注：" prop="remark">
              <el-col :span="20">
                {{ fromData.remark }}
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
        <nh-area-title>
          <div class="second_tips">
            结算信息
          </div>
        </nh-area-title>
        <el-row>
          <el-col :span="12">
            <el-form-item label="所属签约公司:" prop="ext.belongEnterpriseName">
              <el-col :span="24">
                {{ fromData.ext.belongEnterpriseName }}
              </el-col>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="统一社会信用代码:" prop="ext.belongCreditCode">
              <el-col :span="24">
                {{ fromData.ext.belongCreditCode }}
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="visible = false"
      >确 定</el-button>
    </span>
  </wms-dialog>
</template>

<script>
import loadingMixin from '@thales/loading';
import WmsDialog from '@/wms/components/WmsDialog.vue';

import cloneDeep from 'lodash/cloneDeep';
import { getTenantDetail, organizationTree } from '@/api/tenant';
import { localStorageGet } from '@/utils/localStorage';
import { USER } from '@/constant/storage';
import {
  TENANT_TYPE,
  SUBJECT_TYPE, STATUS,
} from '../constant';

import {
  rules, fromData,
} from './config';

export default {
  name: 'AddDialog',
  components: { WmsDialog },
  mixins: [loadingMixin],
  data() {
    return {
      userInfo: localStorageGet(USER),
      id: null,
      visible: false,
      isEdit: false,
      TENANT_TYPE,
      SUBJECT_TYPE,
      STATUS,
      fromData: cloneDeep(fromData),
      ext: {},
      enableOption: [
        {
          value: 'subordinate_level',
          label: '含下级',
        },
        {
          value: 'own_level',
          label: '自己',
        },
        {
          value: 'same_level',
          label: '同级',
        },
      ],
      dataStatus: {
        subordinate_level: '含下级',
        own_level: '自己',
        same_level: '同级',
      },
      isCompany: [],
      parentTenantOptions: [],
      rules,
      creditCodeError: '',
      loading: {
        getTenantInfo: false,
        handleRemoteSuperior: false,
        handleSave: false,
      },
      organizationTree: [],
      authorizationTree: [],
      defaultAuthorizationProps: {
        label: 'name',
      },

    };
  },
  methods: {
    positionYx(e) {
      this.center = {
        lat: e.position.lat,
        lng: e.position.lng,
      };
    },
    async init(row) {
      const isEdit = !!row.tenantId;
      this.fromData = cloneDeep(fromData);
      this.isEdit = isEdit;
      if (isEdit) {
        const result = await getTenantDetail({
          tenantId: row.tenantId,
          needProperty: true,
          needAuthedSystem: true,
        });
        if (!result.ext) {
          result.ext = {
            belongCreditCode: '',
            belongEnterpriseName: '',
          };
        }
        this.fromData = Object.assign(this.fromData, result);
        if (result.properties && result.properties.length > 0) {
          const properties = [
            {
              key: 'MANAGER_NAME',
              value: '',
              type: 'ENTERPRISE_MANAGER',
            }, {
              key: 'MANAGER_MOBILE',
              value: '',
              type: 'ENTERPRISE_MANAGER',
            },
          ];
          result.properties.forEach((item) => {
            if (item.key === 'MANAGER_NAME') {
              properties[0].value = item.value;
            }
            if (item.key === 'MANAGER_MOBILE') {
              properties[1].value = item.value;
            }
          });
          this.fromData.property.properties = properties;
        }
        this.visible = true;
        this.authorizationTree = result.systems.map((item) => {
          const { nodes } = item;
          return {
            ...item,
            children: nodes,
          };
        });
        this.getOrganizationTree(row.tenantId);
        this.getTenantName(this.fromData.parentTenantId);
      }
    },
    async getTenantName(parentTenantId) {
      if (parentTenantId) {
        const info = await getTenantDetail(
          { tenantId: parentTenantId },
        );
        this.fromData.parentTenant = info.tenantName;
      }
    },
    // 组织树
    async getOrganizationTree(id) {
      const resp = await organizationTree({
        code: id,
        createTopNote: true,
        type: 'TENANT',
        orgName: this.fromData.tenantName,
      });
      this.organizationTree = resp || [];
    },

    handleClose() {
      this.$refs.ruleForm.resetFields();
      this.parentTenantOptions = [];
      this.organizationTree = [];
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .dialog_content .el-input .el-input__inner {
  width: 210px !important;
}

::v-deep .dialog_content .businessCreditInput .el-input__inner {
  width: 320px !important;
}

::v-deep .el-drawer__header {
  margin-bottom: 0;
  padding-bottom: 20px;
  border-bottom: 1px solid #f5f5f5;
}

.dialog_content_info {
  padding: 0 20px;
  max-height: auto;
}

.verify_box {
  position: relative;
  height: 48px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 3px;
    height: 16px;
    background-color: #059E84;
  }
}
.company_name {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
  span {
    font-size: 14px;
    font-weight: 600;
    color: #323233;
    margin-right: 15px;
  }
}
.second_tips {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  img {
    margin: 0 6px 0 10px;
  }
  span {
    color: #fe5e08;
    font-size: 14px;
  }
}
.verify_org {
  &_title {
    font-size: 24px;
    font-weight: bold;
    margin-right: 10px;
  }
}
.camp_tips {
  width: 100%;
  min-height: 48px;
  background: #f9f1ec;
  border-radius: 4px;
  border: 1px solid #fbbb98;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 15px;
  padding: 0 16px;
  box-sizing: border-box;
  span {
    font-size: 14px;
    color: #fe5e08;
    margin-right: 8px;
  }
}
.edit_title {
  font-size: 16px;
  font-weight: 500;
  color: #323233;
}
.edit_link_image {
  font-size: 14px;
  font-weight: 500;
  color: #00af66;
  margin-left: 15px;
}
.prevImage {
  &_content {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
    img {
      height: 80vh;
    }
  }
  &_mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9992;
  }
}
</style>
